import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import slotImage from "@images/box/illustration_slot.svg"
import templateImage from "@images/box/illustration_template.png"
import { ArrowToTheTopIcon } from "@images/svgIcons/arrowToTheTopIcon"
import { TypicalWeekIcon } from "@images/svgIcons/typicalWeekIcon"
import { word } from "@modules/core/utils/i18n"

export type BoxSlotTemplateToolProps = {
  hideTemplateExplanation: () => void
  className?: string
} & React.ComponentProps<"div">

export function BoxSlotTemplateToolComponent({
  hideTemplateExplanation,
  className,
  ...props
}: BoxSlotTemplateToolProps) {
  return (
    <div
      className={cn(
        "flex min-h-[calc(100vh-300px)] min-w-125 flex-col items-center gap-20 rounded-4xl bg-surface-foreground p-11",
        className,
      )}
      {...props}
    >
      <Text fontStyle="HL" className="text-center">
        {word("box.activity.inform.complementayTools")}
      </Text>
      <div className="relative mt-6 flex items-center justify-center gap-20 self-stretch">
        <div className="flex max-w-85 flex-col items-center justify-center gap-2">
          <Text fontStyle="BS">{word("box.activity.inform.singleSlot")}</Text>
          <img src={slotImage} />
        </div>
        <div className="flex max-w-85 flex-col items-center justify-center gap-2">
          <div className="flex flex-row gap-2">
            <TypicalWeekIcon color="currentColor" className="text-textDefault-body" />
            <Text fontStyle="LM">{word("box.programmation.activity.typicalWeek")}</Text>
          </div>
          <Text fontStyle="BS">{word("box.activity.inform.template")}</Text>
          <img src={templateImage} className="h-28" />
        </div>
        <ArrowToTheTopIcon color="currentColor" className="absolute right-0 h-110 w-20 text-neutral-300" />
      </div>

      <Button variant="primary" onClick={() => hideTemplateExplanation()}>
        {word("global.understood")}
      </Button>
    </div>
  )
}
